export default "float linear(float t) {\n  return t;\n}\n\n"